import React from "react";
import { observer } from "mobx-react";
import { ReportUpdateStore } from "../../store";
import { ReportUpdateForm } from "./ReportUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type ReportUpdateProps = {
  reportUpdateStore: ReportUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const ReportUpdate: React.FC<ReportUpdateProps> = observer(
  ({ reportUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={reportUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={reportUpdateStore.savedButOutdated}
          onReload={() => reportUpdateStore.reloadReport()}
          reloadDisabled={reportUpdateStore.isProcessing}
        />
        <ReportUpdateForm
          reportUpdateStore={reportUpdateStore}
          nameError={reportUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            reportUpdateStore.setNameValue(value);
          }}
          name={reportUpdateStore.entityValues.name}
          reportTypeError={reportUpdateStore.errors.reportType?.message}
          onReportTypeChange={(value) => {
            reportUpdateStore.setReportTypeValue(value);
          }}
          reportTypeSelectedValue={
            reportUpdateStore.entityValues.showReportType
          }
          onReportTypeSelected={(value) => {
            reportUpdateStore.setSelectedReportType(value);
          }}
          reportTypeOptions={reportUpdateStore.getReportTypeOptions()}
          templateError={reportUpdateStore.errors.template?.message}
          onTemplateChange={(value: string) => {
            reportUpdateStore.setTemplateValue(value);
          }}
          template={reportUpdateStore.entityValues.template}
          constantsError={reportUpdateStore.errors.constants?.message}
          onConstantsChange={(value: string) => {
            reportUpdateStore.setConstantsValue(value);
          }}
          constants={reportUpdateStore.entityValues.constants}
          descriptionError={reportUpdateStore.errors.description?.message}
          onDescriptionChange={(value: string) => {
            reportUpdateStore.setDescriptionValue(value);
          }}
          description={reportUpdateStore.entityValues.description}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={reportUpdateStore.saveDisabled}
          onSave={() => reportUpdateStore.saveReport()}
          onCancel={() => reportUpdateStore.cancelReport()}
        />
        <ErrorDialog
          open={reportUpdateStore.errorDialogOpened}
          title={reportUpdateStore.errorTitle}
          description={reportUpdateStore.errorDescription}
          onClose={() => reportUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={reportUpdateStore.confirmDialogOpened}
          title={reportUpdateStore.confirmDialogTitle}
          description={reportUpdateStore.confirmDialogDescription}
          onConfirm={() => reportUpdateStore.executeConfirmedAction()}
          onCancel={() => reportUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
